import './scroll-to-top--split';



// WEBPACK FOOTER //
// ./client/src/core/components/scroll-to-top/index.js